export default "__VITE_ASSET__BBkBbs_Q__"